import { Router, Utils } from '@lightningjs/sdk';
import AuthRoute from '../../components/layouts/AuthRoute/AuthRoute';
import SettingsMenu from './components/SettingsMenu';
import Lightning from '@lightningjs/sdk/src/Lightning';

export default class Settings extends AuthRoute {
  static _template() {
    return {
      ...super._template(),
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
          zIndex: 99,
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      Settings: {
        w: 1570,
        h: 880,
        x: 350,
        y: 200,
        plinko: true,
        SettingsTitle: {
          text: {
            text: 'Settings',
            fontSize: 60,
          },
        },
        SettingsMenu: {
          collision: true,
          type: SettingsMenu,
          y: 100,
        },
      },
    };
  }

  _handleBack() {
    let routerPath = Router.getHistory();
    let lasRouterPath = routerPath[routerPath.length - 1].hash;
    if (lasRouterPath.includes('categories')) {
      Router.replaceHistoryState({ hash: 'browse' });
      Router.navigate('browse');
    } else {
      Router.back();
    }
  }

  _handleLeft() {
    if (!Router.isNavigating()) {
      Router.focusWidget('sidebar');
    }
  }

  _getFocused() {
    return this.tag('SettingsMenu');
  }
}
